/// <amd-module name="VSSUI/Components/PersonaCard/OrganizationCard" />
import * as React from "react";
import * as Resources from "VSSUI/VSS.Resources.VSSUI";

import { Label } from "OfficeFabric/Label";
import { format } from "VSS/Core/Util/String";
import { VssPersona } from "VSSUI/VssPersona";
import { OrganizationCardProps } from "./ContactCard.Props";

/** @deprecated */
export class OrganizationCard extends React.Component<OrganizationCardProps> {
    // Render
    public render(): JSX.Element {
        const managerPersonaList = this.createManagerChainPersonaElements();
        const directReportPersonaList = this.createDirectReportsPersonaElements();

        return (
            <div className="contact-or-organization-card-wrapper">
                <div className="organization-card-content">
                    {/* Section for heading */}
                    <div className="organization-card-header-wrapper">
                        <Label>{Resources.PeoplePickerOrganization}</Label>
                    </div>

                    {/* Section for manager chain */}
                    <div className="organization-card-manager-chain-wrapper">{managerPersonaList}</div>

                    {/* Section for "Reporting to [person]" and the Persona list */}
                    {directReportPersonaList.length > 0 && (
                        <div className="organization-card-direct-reports-wrapper">
                            <Label className="organization-card-direct-reports-label">
                                {format(Resources.PeoplePickerReportingTo, this.props.identity.displayName, this.props.directReportList.length)}
                            </Label>
                            {directReportPersonaList}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // Helper methods to create Presona elements
    private createManagerChainPersonaElements() {
        var self = this;

        const managerChainElementList = this.props.managerList
            ? this.props.managerList.map((manager) => {
                const managerData = {
                    imageUrl: manager.image,
                    primaryText: manager.displayName ? manager.displayName : "",
                    secondaryText: manager.jobTitle ? manager.jobTitle : "",
                    tertiaryText: manager.department ? manager.department : ""
                };

                  return (
                      <div
                          className="persona-list-element profile-card-tab-element flex-row"
                          aria-label={manager.displayName}
                          key={manager.entityId + manager.signInAddress}
                          onClick={() => {
                              self.props.onClickEntity(manager);
                          }}
                          data-is-focusable={true}
                          role="button"
                      >
                          <VssPersona
                              displayName={managerData.primaryText}
                              imageUrl={ managerData.imageUrl}
                              size="medium-plus"
                              suppressPersonaCard={true}
                          />

                        <div className="flex-column flex-grow persona-card-name">
                            <div className="persona-list-element-text-primary">{managerData.primaryText}</div>
                            {managerData.secondaryText === "" ? undefined : <div className="persona-list-element-text-secondary">{managerData.secondaryText}</div>}
                        </div>
                      </div>
                  );
              })
            : [];

        // Append current identity to list
        const mainPersonaData = {
            imageUrl: this.props.identity.image,
            primaryText: this.props.identity.displayName,
            secondaryText: this.props.identity.jobTitle,
            tertiaryText: this.props.identity.department
        };
        managerChainElementList.push(
            <div
                className="persona-list-element profile-card-tab-element flex-row"
                aria-label={this.props.identity.displayName}
                key={this.props.identity.entityId + this.props.identity.signInAddress}
                onClick={() => {
                    self.props.onClickEntity(this.props.identity);
                }}
                data-is-focusable={true}
                role="button"
            >
                <VssPersona
                    displayName={mainPersonaData.primaryText}
                    imageUrl={ mainPersonaData.imageUrl}
                    size="medium-plus"
                    suppressPersonaCard={true}
                />
                <div className="flex-column flex-grow persona-card-name">
                    <div className="persona-list-element-text-primary">{mainPersonaData.primaryText}</div>
                    {mainPersonaData.secondaryText === "" ? undefined : <div className="persona-list-element-text-secondary">{mainPersonaData.secondaryText}</div>}
                </div>
            </div>
        );

        return managerChainElementList;
    }

    private createDirectReportsPersonaElements() {
        var self = this;

        const directReportElementList = this.props.directReportList
            ? this.props.directReportList.map((directReport) => {
                const directReportData = {
                    imageUrl: directReport.image,
                    primaryText: directReport.displayName ? directReport.displayName : "",
                    secondaryText: directReport.jobTitle ? directReport.jobTitle : "",
                    tertiaryText: directReport.department ? directReport.department : ""
                };

                  return (
                      <div
                          className="persona-list-element profile-card-tab-element flex-row"
                          aria-label={directReport.displayName}
                          key={directReport.entityId + directReport.signInAddress}
                          onClick={() => {
                              self.props.onClickEntity(directReport);
                          }}
                          data-is-focusable={true}
                          role="button"
                      >
                          <VssPersona
                            displayName={directReportData.primaryText}
                            imageUrl={ directReportData.imageUrl}
                            size="medium-plus"
                            suppressPersonaCard={true}
                        />
                        <div className="flex-column flex-grow persona-card-name">
                            <div className="persona-list-element-text-primary">{directReportData.primaryText}</div>
                            {directReportData.secondaryText === "" ? undefined : <div className="persona-list-element-text-secondary">{directReportData.secondaryText}</div>}
                        </div>
                      </div>
                  );
              })
            : [];

        return directReportElementList;
    }
}
